var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 24C47 37.2548 36.4787 48 23.5 48C10.5213 48 0 37.2548 0 24C0 10.7452 10.5213 0 23.5 0C36.4787 0 47 10.7452 47 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0633 12.3744C30.8904 11.0297 30.1853 9.27626 30.1853 7.35938H28.7153C29.0939 9.45458 30.3411 11.2526 32.0633 12.3744Z",
    fill: "#E9540D",
    stroke: "black",
    strokeWidth: 0.00106731
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4632 23.207C15.9169 23.207 13.8458 25.28 13.8458 27.8283C13.8458 29.6042 14.8554 31.1495 16.3252 31.9221C15.7759 31.1643 15.4492 30.2357 15.4492 29.2251C15.4492 26.6768 17.5204 24.6038 20.0667 24.6038C20.5418 24.6038 21.002 24.6854 21.4327 24.8192V19.2024C20.9872 19.1429 20.5344 19.1057 20.0667 19.1057C19.985 19.1057 19.9108 19.1132 19.8291 19.1132V23.4224C19.3911 23.2886 18.9383 23.207 18.4632 23.207Z",
    fill: "#E9540D",
    stroke: "black",
    strokeWidth: 0.00106731
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2277 14.8411V19.1132C33.3771 19.1132 30.7344 18.1994 28.5814 16.6539V27.8357C28.5814 33.4156 24.0457 37.9626 18.4632 37.9626C16.3104 37.9626 14.306 37.2791 12.6654 36.1274C14.5139 38.1111 17.1492 39.3594 20.0667 39.3594C25.6417 39.3594 30.185 34.8197 30.185 29.2325V18.0507C32.3378 19.5962 34.9805 20.5099 37.8312 20.5099V15.012C37.2744 15.012 36.7399 14.9525 36.2277 14.8411Z",
    fill: "#E9540D",
    stroke: "black",
    strokeWidth: 0.00106731
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5814 27.8358V16.654C30.7344 18.1994 33.3771 19.1132 36.2277 19.1132V14.8411C34.5797 14.492 33.1323 13.6004 32.0633 12.3744C30.3411 11.2526 29.1011 9.45458 28.7076 7.35938H24.6841L24.6766 29.4035C24.5876 31.8702 22.5535 33.854 20.0667 33.854C18.5225 33.854 17.164 33.0888 16.3178 31.9297C14.8479 31.1496 13.8383 29.6116 13.8383 27.8358C13.8383 25.2875 15.9095 23.2145 18.4557 23.2145C18.9308 23.2145 19.3911 23.2962 19.8217 23.43V19.1207C14.358 19.2396 9.94836 23.7271 9.94836 29.2326C9.94836 31.8924 10.9802 34.3147 12.6654 36.1275C14.306 37.2792 16.3103 37.9627 18.4632 37.9627C24.0382 37.9627 28.5814 33.4156 28.5814 27.8358Z",
    fill: "#E9540D",
    stroke: "black",
    strokeWidth: 0.00106731
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/t.9a09738f9712d5f243269618674e5f90.svg";
export { ForwardRef as ReactComponent };